var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2449_2470)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.11248 21.4338H7.84462V5.51413L6.39462 4.58556C4.2964 3.2427 1.53569 4.74627 1.53569 7.23199V19.8641C1.53569 20.732 2.24283 21.4356 3.11426 21.4356",
    stroke: "#9A8784",
    strokeWidth: 1.78571,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.53569 7.23213V9.33213L7.84462 13.3732L12.5768 16.4053L17.3089 13.3732L23.6196 9.33213V7.23035C23.6196 4.74463 20.8571 3.24106 18.7571 4.58749L17.3107 5.51606L12.5768 8.54642L7.84462 5.51427L6.39462 4.5857C4.2964 3.24285 1.53569 4.74642 1.53569 7.23213Z",
    stroke: "#9A8784",
    strokeWidth: 1.78571,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3089 21.4339H22.0411C22.2479 21.4346 22.4528 21.3945 22.6441 21.3158C22.8354 21.2372 23.0092 21.1215 23.1557 20.9756C23.3022 20.8296 23.4184 20.6561 23.4977 20.4651C23.577 20.2741 23.6179 20.0693 23.6179 19.8625V7.23035C23.6179 4.74463 20.8571 3.24106 18.7571 4.58749L17.3107 5.51606L17.3089 21.4339Z",
    stroke: "#9A8784",
    strokeWidth: 1.78571,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2449_2470"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmail);
export default __webpack_public_path__ + "static/media/gmail.f930e6ebd6527bb78de7fd7fb6cf7a8b.svg";
export { ForwardRef as ReactComponent };